import axios from 'axios';

export const PERFORM_REQUEST = 'PERFORM_REQUEST';
export const PERFORM_REQUEST_PAST = 'PERFORM_REQUEST_PAST';
export const PERFORM_REQUEST_SUCCESS =
  'PERFORM_REQUEST_SUCCESS';
export const PERFORM_REQUEST_FAILURE =
  'PERFORM_REQUEST_FAILURE';
export const SET_PAGE = 'SET_PAGE';
export const INIT_CATEGORIES = 'INIT_CATEGORIES';
export const INIT_CATEGORY = 'INIT_CATEGORY';
export const INIT_TAG = 'INIT_TAG';
export const INIT_TAGS = "INIT_TAGS"
export const INIT_TITLE = 'INIT_TITLE';
export const SET_CATEGORY = 'SET_CATEGORY';
export const INIT_LANGUAGE = 'INIT_LANGUAGE';
export const SET_TAG = "SET_TAG"; 
export const INIT_PAGE_SIZE = "INIT_PAGE_SIZE";
export const CLEAR_RESULTS = "CLEAR_RESULTS";
export const INIT_LOAD_MORE = "INIT_LOAD_MORE";
export const INIT_LINK = "INIT_LINK";
export function performRequest() {
  return (dispatch, getState) => {
      dispatch({ type: PERFORM_REQUEST });
      var cat = 0;
      var tag = 0; 
      if (getState().category != '')
          cat = getState().category;
      if (getState().tag != '')
          tag = getState().tag;
      return axios
            .get('/api/v1/articles/getarticles/',{
            params: {
                lang: getState().language,
                page: getState().page,
                size: getState().size,
                category: cat,
                tag: tag,
                link: getState().link
                },
              })
        .then(response => {
            dispatch({
              type: PERFORM_REQUEST_SUCCESS,
              data: response.data,
            });
          })
          .catch(error => {
            console.error('PERFORM_REQUEST_FAILURE', error);
            dispatch({ type: PERFORM_REQUEST_FAILURE });
          });
  };
}

export function initLoadMore(loadMore) {
  return {
    type: INIT_LOAD_MORE,
    loadMore
  }
}

export function clearResults() {
  return {
    type: CLEAR_RESULTS
  }
}
export function initPageSize(size) {
    return {
        type: INIT_PAGE_SIZE,
        size
    };
}

export function setSearchQuery(query) {
  return {
    type: SET_SEARCH_QUERY,
    query,
  };
}

export function setPage(page) {
  return {
    type: SET_PAGE,
    page,
  };
}

export function setCategory(category) {
  return {
    type: SET_CATEGORY,
    category,
  };
}
export function setTag(tag) {
    return {
        type: SET_TAG,
        tag,
    };
}

export function initLink(link) {
  return {
    type: INIT_LINK,
    link
  }
}

export function initCategories(categories) {
  return {
    type: INIT_CATEGORIES,
    categories,
  };
}
export function initTags(tags) {
    return {
        type: INIT_TAGS,
        tags,
    };
}
export function initTag(tag) {
    return {
        type: INIT_TAG,
        tag,
    }
}
export function initCategory(category) {
    return {
        type: INIT_CATEGORY,
        category,
    }
}
export function initTitle(title) {
  return {
    type: INIT_TITLE,
    title,
  };
}

export function initLanguage(language) {
  return {
    type: INIT_LANGUAGE,
    language,
  };
}


